import { render, staticRenderFns } from "./DropProjectOnUserModal.vue?vue&type=template&id=80e7af7e"
import script from "./DropProjectOnUserModal.vue?vue&type=script&lang=js"
export * from "./DropProjectOnUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports